export const fetchReferralCode = () => {
    try {
        const params = new URLSearchParams(window.location.search);
        return params.get("ref");
    } catch (error) {
        console.error("Failed to fetch affiliate referral:", error);
        return null;
    }
};

export const captureAffiliateReferral = () => {
    try {
        const params = new URLSearchParams(window.location.search);

        const referralCode = params.get("ref");

        if (referralCode) {
            localStorage.setItem(
                "af_rc",
                referralCode
            );
        }
    } catch (error) {
        console.error(
            "Failed to capture affiliate referral:",
            error
        );
    }
};

export const getAffiliateReferralCode = () => {
    return localStorage.getItem(
        "af_rc"
    );
};

export const clearAffiliateReferralCode = () => {
    localStorage.removeItem(
        "af_rc"
    );
};